"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[10761],{

/***/ 10761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TermsAndConditions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/legal/legal.module.scss
var legal_module = __webpack_require__(14777);
var legal_module_default = /*#__PURE__*/__webpack_require__.n(legal_module);
;// CONCATENATED MODULE: ./src/components/shared/legal/fallbacks/termsAndConditionsFallback.tsx



function TermsAndConditionsFallback({ domainName , categoryName , className , mainWrapperClassName  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${mainWrapperClassName ?? (legal_module_default()).legal} ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        "To enhance the user experience on ",
                        domainName,
                        ", we collect data about the visitor device including operating system, web browser, java script enabling status, IP address, and referral URL. We may use this data to re-market our website to those visitors by launching advertising campaigns on reputable advertising companies. By accessing ",
                        domainName,
                        ", we assume you accept these terms and conditions. Do not continue to use ",
                        domainName,
                        " if you do not agree to take all of the terms and conditions stated on this page."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Privacy Policy"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Registration data and other personal information about you collected on the Website, which may include personally identifiable information you voluntarily submit, are subject to the Website's Privacy Policy."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "The Privacy Policy can be found at ",
                            domainName,
                            "/privacy-policy."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Consent: By using our Website, ",
                            domainName,
                            ", you consent to the collection and use of these information in accordance with the Privacy Policy."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "The Website “",
                            domainName,
                            "”"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "The Website is designed to help you locate information about",
                            " ",
                            categoryName,
                            ". The Website also connects you with contractors and other providers who may be able to assist you with your ",
                            categoryName,
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "Use of the Website “",
                            domainName,
                            "”"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "list-inside list-disc",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "You can use the Website for your individual personal use and you agree that you will not re-produce, duplicate, use, trade or otherwise exploit the Website for any commercial or non-personal purposes."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "You agree to access the Website through the interface provided by the Website using a standard web browser."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "You may not decompile, reverse engineer, disassemble, rent, lease, loan, sell, sublicense, or create derivative works from the Website or its content. Nor may you use any network monitoring, discovery software or other programs or methods to determine the Website architecture or to extract content from the Website or information about its usage or users."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Intellectual Property"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "We own and retain all intellectual property aspects in the Website, ",
                            domainName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Copyright Infringement"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "If you are a copyright owner or agent thereof and believe that content on the Website infringes upon your copyright, please submit notice, pursuant to the Copyright Protection Law of the defending party's jurisdiction to our Copyright Agent with the following information:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "list-inside list-disc",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "An electronic or physical signature of the person authorized to act on behalf of the owner of the copyright;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "A description of the copyrighted work that you claim has been infringed;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "The URL of the location containing the material that you claim is infringing;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Your address, telephone number, and email address;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "A statement by you that you have a good faith belief that the disputed use is not authorized by the copyright owner, its agent, or the law;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "A statement by you, made under penalty of perjury, that the above information in your notice is accurate and that you are the copyright owner or authorized to act on the copyright owner's behalf."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Our Copyright Agent can be reached By email:",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: `mailto:info@${domainName?.toLowerCase()}`,
                                children: [
                                    "info@",
                                    domainName
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Modification or Termination of Services"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "You acknowledge and agree that we may modify or terminate the services provided on the Website and any of its features at any time or terminate your access to them without notice to you. You acknowledge and agree that we shall not be liable to you or any third party as a result of any such modification or termination. You may discontinue use of the Website at any time without notice to us."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Links to Other Websites"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Some information provided to you on our Website may contain links to information that resides on third-party websites not owned or controlled by us. Unless the link is to an article or content on another website owned by us, we do not claim ownership to the content on other websites you reach by clicking on a link from the Website. Your rights to such content will be governed by the terms of those third-party websites. You acknowledge and agree that we are not responsible for any third-party content and that you must evaluate any such third-party content and bear all risks associated with any use of the content, including any reliance on the accuracy or completeness of the information."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Limitation of Liability"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "In no event shall $",
                            domainName,
                            ', or its directors, officers, partners, employees, representatives, affiliates, or assigns ("the ',
                            domainName,
                            ' parties") be liable to you for your accessing of this website or under or related to this agreement for any indirect, special, punitive, incidental, reliance, exemplary or consequential damages, loss of profits, loss of expected savings, or any other non-direct damages howsoever caused whether or not ',
                            domainName,
                            " or any of the ",
                            domainName,
                            " parties have been advised of the possibility of such damages. ",
                            domainName,
                            "'s and the",
                            " ",
                            domainName,
                            " parties' collective maximum liability to you under or related to this agreement shall in no event exceed the amount paid by you for use of the website or services provided on the website, if any. The limitations of liability and disclaimers in this agreement shall apply regardless of the form of action, whether in contract, warranty, strict liability, negligence or other tort and shall survive a fundamental breach or breaches or the failure of the essential purpose of contract or the failure of an exclusive remedy. Because some jurisdictions do not allow the exclusion or limitation of incidental or consequential damages, ",
                            domainName,
                            "'s and the ",
                            domainName,
                            " ",
                            "parties' liability in such jurisdictions shall be limited to the fullest extent permitted by law."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Disclaimer and Indemnity"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "You agree to defend, indemnify and hold harmless",
                            " ",
                            domainName,
                            " and its directors, officers, partners, employees, representatives, contractors, affiliates, successors or assigns, including all third parties mentioned on the Website, from and against any and all claims, actions or demands, including without limitation reasonable legal and accounting fees, alleging or resulting from your use of the Website or the services and the content thereon or your breach of this Agreement."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Statute of Limitations Disclaimer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or related to use of the Website or the Agreement must be filed within one (1) year after such claim or cause of action arose or be forever barred."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Dispute Resolution and Arbitration"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "By using this Website, you agree that any and all disputes, claims, or controversies arising out of or relating to your access to or use of the Website or any services provided through it — including the interpretation, applicability, enforceability, or formation of this arbitration provision — shall be resolved solely and exclusively by binding arbitration administered by the American Arbitration Association (AAA) under its Commercial Arbitration Rules, which are hereby incorporated by reference."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "You and ",
                            domainName,
                            " expressly agree that the arbitrator shall have exclusive authority to determine the existence, scope, validity, and arbitrability of any dispute, including any objections with respect to the formation or enforceability of this arbitration clause."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Arbitration shall be conducted in the State of Delaware, and judgment upon the award rendered by the arbitrator may be entered in any court having jurisdiction."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "All arbitration proceedings must be conducted on an individual basis only. You and ",
                            domainName,
                            " hereby waive the right to bring or participate in any class action, class arbitration, or other representative proceeding."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Choice of Law"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "This Agreement, ",
                            domainName,
                            " Terms and Conditions, shall be governed by and construed under the laws of the defending party's jurisdiction without giving effect to its conflict of laws principles. You and ",
                            domainName,
                            " hereby submit to the exclusive forum, jurisdiction and venue of the courts located in defending party's jurisdiction for any claim related to, arising from or in connection with this Agreement and/or your use of the Website."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Cookies"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "The websites might employ the use of cookies. By accessing Website Name, ",
                            domainName,
                            ", you agreed to use cookies in agreement."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "iFrames/Inline Frame"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website,",
                            " ",
                            domainName,
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Disclaimers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            'All content and services provided on or through this website are provided "as is" and "as available" for your use. The content is provided without warranties or conditions of any kind, either expressed or implied, including but not limited to implied warranties and conditions of merchantability, fitness for a particular purpose or non-infringement. Neither ',
                            domainName,
                            ", its affiliates and related entities, nor any of their respective employees, agents, third party content providers or licensors warrant that: the website or content thereon will be up-to-date, complete, comprehensive, accurate or applicable to your circumstances; the quality of any products, services, information, or other material obtained by you through the website will meet your expectations; this website will be available at any particular time or location; or any defects or errors will be corrected or that the website is free of viruses or other harmful components. Your use of this website is solely at your own risk."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: "list-inside list-disc",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Limit or exclude our or your liability for death or personal injury;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Limit or exclude our or your liability for fraud or fraudulent misrepresentation;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Limit any of our or your liabilities in any way that is not permitted under applicable law; or"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: "Exclude any of our or your liabilities that may not be excluded under applicable law."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature."
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/components/shared/legal/termsAndConditions.tsx






function TermsAndConditions({ domainNameAsProp , categoryNameAsProp ="Auto Warranty and Car insurance" , className , mainWrapperClassName  }) {
    const { domain: { name: actualDomainName , niceName , textBlocks , translations  } , category , domainNameTranslation ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const domainName = niceName ?? actualDomainName ?? domainNameAsProp;
    const categoryName = category?.name ?? categoryNameAsProp;
    const replaceDomainName = (text)=>{
        return text.replace(/{domainName}/g, domainName)?.replace(/{categoryName}/g, categoryName)?.replace(/{mailInfo}/g, domainName.toLowerCase());
    };
    const terms = textBlocks?.find((textBlock)=>textBlock.position === "custom-domain-terms-and-conditions") || textBlocks?.find((textBlock)=>textBlock.position === "custom-category-terms-and-conditions");
    return terms ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${mainWrapperClassName ?? (legal_module_default()).legal} ${className ?? ""}`,
        dangerouslySetInnerHTML: {
            __html: `
                ${terms.updatedAt ? `<div class="timeStyle">${translations?.[`${domainNameTranslation}_LastUpdated`] ?? "Last Updated:"} ${(0,sharedUtils/* formatTimestamp */.i$)(terms.updatedAt)}</div>` : ""}
                ${replaceDomainName(terms.text)}`
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditionsFallback, {
        domainName: domainName,
        categoryName: categoryName,
        className: className,
        mainWrapperClassName: mainWrapperClassName
    });
}


/***/ })

}]);